import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react';
import * as actions from '../Actions.js';

export class FormDetailLicitacoes extends Component {
  static propTypes = {
    pageLicitacoes: PropTypes.object.isRequired,
    findLicitacoes: PropTypes.func.isRequired,
    idEmenda: PropTypes.number.isRequired
  };

  componentDidMount() {
    this.searchWithPage(
      this.props.pageLicitacoes.set('number', 0).set('size', 20)
    );
  }

  searchWithPage = page => {
    const { findLicitacoes, idEmenda } = this.props;
    findLicitacoes(idEmenda, page);
  };

  renderRow = (licitacao, index) => {
    const entidade = licitacao.get('entidade');
    const exercicio = licitacao.get('exercicio');
    const tipoLicitacao = licitacao.get('tipoLicitacao');
    const numeroLicitacao = licitacao.get('numeroLicitacao');
    const ano = licitacao.get('ano');
    const exercicioLicitacao = ano || exercicio;
    const modalidade = licitacao.get('modalidade');
    const numeroContrato = licitacao.get('numeroContrato');
    const anoContrato = licitacao.get('anoContrato');
    const fornecedorContrato = licitacao.get('fornecedorContrato');
    const idOxy =
      licitacao.get('idOxy') || licitacao.get('oxyId') || licitacao.get('id');
    const detalhesUrl = `/licitacoes/detalhes?entidade=${entidade}&exercicio=${exercicioLicitacao}&tipoLicitacao=${tipoLicitacao}&licitacao=${numeroLicitacao}${
      idOxy ? `&oxyId=${idOxy}` : ''
    }`;

    return (
      <tr key={index}>
        <td>{`${numeroLicitacao}/${ano}`}</td>
        <td>{modalidade}</td>
        <td>
          {numeroContrato && anoContrato
            ? `${numeroContrato}/${anoContrato}`
            : ''}
        </td>
        <td>{fornecedorContrato || ''}</td>
        <td>
          <Link to={detalhesUrl}>Mais Detalhes</Link>
        </td>
      </tr>
    );
  };

  render() {
    const { pageLicitacoes } = this.props;
    const content = pageLicitacoes.get('content', List());

    return (
      <div>
        {content.size > 0 ? (
          <table className="panel-table striped fancy">
            <TableHeader empty={content.isEmpty()}>
              <tr>
                <th>Licitação</th>
                <th>Modalidade</th>
                <th>Contrato</th>
                <th>Fornecedor</th>
                <th>Ações</th>
              </tr>
            </TableHeader>
            <tbody>{content.map(this.renderRow)}</tbody>
          </table>
        ) : (
          <div className="empty-state">Nenhuma licitação encontrada.</div>
        )}
        <SearchPagination
          page={pageLicitacoes}
          searchWithPage={this.searchWithPage}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pageLicitacoes: state.emendaContabilidade.get('licitacoes')
  };
}

const allActions = {
  findLicitacoes: actions.findLicitacoes
};

export default connect(mapStateToProps, allActions)(FormDetailLicitacoes);
